import {Component} from '@angular/core';

@Component({
  selector: 'app-reset-token-exist',
  templateUrl: './reset-token-exist.component.html',
  styleUrl: './reset-token-exist.component.scss'
})
export class ResetTokenExistComponent {
}
